import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactNode } from 'react';

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.palette.tokens.space[3],
  padding: `${theme.palette.tokens.space[14]}px ${theme.palette.tokens.space[6]}px`,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  '& > .material-symbols-outlined': {
    fontSize: '24px',
    color: theme.palette.text.disabled,
  },
}));

const Message = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.secondary,
  maxWidth: '420px',
}));

interface EmptyStateProps {
  /** What this space will show once there is data — one sentence. */
  message: string;
  icon?: ReactNode;
  /** A secondary button with the action that fills the space. */
  action?: ReactNode;
}

/** Empty state (guide 7.11): a sentence and an action. No illustration. */
export function EmptyState({
  message,
  icon,
  action,
}: EmptyStateProps): JSX.Element {
  return (
    <Root role="status">
      {icon}
      <Message>{message}</Message>
      {action}
    </Root>
  );
}
